import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TextField, Button } from 'utils';
import CircularLoader from 'utils/loader/circular-loader';
import useGcList from './use-gc-list';
import styles from './gc-list.module.scss';

import GCPurchase from './GCPurchase.js';
import GiftCard from './gift-card';

function imagesBySku(item) {
    switch (item.sku) {
        case 'EGCGBSRTPL001':
            return 'giftcardblack.jpg';
        case 'EGCGBAMZSVSRTP001':
            return 'shoppingvoucher.jpg';
        default:
            return item.images.small;
    }
}

function nameBySku(item) {
    switch (item.sku) {
        case 'EGCGBSRTPL001':
            return 'Amazon Pay Gift Card';
        case 'EGCGBAMZSVSRTP001':
            return 'Amazon Shopping Voucher';
        default:
            return item.name || item.brandName;
    }
}

function GiftCardsList({ isTopBrands }) {
    const {
        loading,
        search,
        giftCards,
        selectedGc,
        prevPageFirstDocs,
        handleSearchClick,
        onSearchChange,
        setSelectedGc,
        handleReset,
        handleNextClick,
        handlePrevclick
    } = useGcList({ isTopBrands });
    
    if (loading) {
        return (
            <div className={styles.loader}>
                <CircularLoader />
            </div>
        );
    }

    if (selectedGc) {
        return (
            <>
                <ArrowBackIcon onClick={() => setSelectedGc(null)} />
                {/* <GCPurchase GCard={selectedGc} /> */}
                <GiftCard card={selectedGc} />
            </>
        );
    }

    if (!giftCards?.data?.length) {
        return (
            <div className={styles.error}>
                <p>We're sorry, Gift Cards are not available at this time!</p>
                <Button onClick={handleReset}>Refresh</Button>
            </div>
        );
    }

    if (!giftCards?.data?.length) {
        return (
            <p className={styles.error}>
                We're sorry, Gift Cards are not available at this time!
            </p>
        );
    }

    return (
        <>
            <div className={styles.header}>
                <TextField
                    name="search_key"
                    placeholder="Search by name"
                    value={search}
                    onChange={onSearchChange}
                />
                <Button variant="secondary" onClick={handleSearchClick}>
                    Search
                </Button>

                <Button variant="alert" onClick={handleReset}>
                    Reset
                </Button>
            </div>

            {giftCards.data && (
                <>
                    <div className={styles.cards}>
                        {giftCards.data.map((item) => {
                            return (
                                <div
                                    className={styles.card}
                                    key={'product_id_' + item.sku}
                                    onClick={(bh) => setSelectedGc(item)}
                                >
                                    <div className={styles.banner}>
                                        <img
                                            className={styles.image}
                                            src={imagesBySku(item)}
                                            alt="icon"
                                        />
                                        {item.offer > 0 ? (
                                            <div className={styles.offer}>
                                                <div
                                                    className={
                                                        styles.innerWrapper
                                                    }
                                                >
                                                    <img
                                                        className="offer_bg"
                                                        src="discountBG.svg"
                                                        alt="discount-icon"
                                                    />
                                                    <div className={styles.off}>
                                                        <p>{item.offer}%</p>
                                                        <p>off</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    <p className={styles.brand}>
                                        {nameBySku(item)}
                                    </p>
                                    <p className={styles.sku}>
                                        <strong>SKU:</strong> {item.sku}{' '}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.buttons}>
                        <Button
                            onClick={handlePrevclick}
                            disabled={prevPageFirstDocs.length < 1}
                        >
                            Prev
                        </Button>

                        <p className={styles.text}>
                            Page: {prevPageFirstDocs.length + 1}
                        </p>

                        <Button
                            disabled={giftCards.data.length < 20}
                            onClick={handleNextClick}
                        >
                            Next
                        </Button>
                    </div>
                </>
            )}
        </>
    );
}

export default GiftCardsList;
